import type { Client } from './client';
import { ensureUser } from './user';

export async function syncProfileToGameClient(
  client: Client,
  options?: { strictExistingToken?: boolean }
): Promise<boolean> {
  try {
    const { user, loginToken } = await ensureUser(options);
    const nickname = user.nickname?.trim();
    if (nickname) {
      client.nicks.set(client.playerId(), nickname);
    }
    if (Number.isInteger(user.avatarIndex)) {
      client.avatars.set(client.playerId(), user.avatarIndex);
    }
    client.bindLoginToken(loginToken);
    return true;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('failed to sync user profile', err);
    return false;
  }
}
